import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateVehicleModel } from '../../enums/VehicleModelEnums';
import { findAllBrand } from '../../actions/brand';

const ModalForAddVehicleModel = ({
  show,
  handleClose,
  handleAdd,
  vehicleModelReducer,
  brandReducer,
}) => {
  const dispatch = useDispatch();
  const { error } = vehicleModelReducer;
  const { brandList } = brandReducer;


  useEffect(() => {
    if (show) {
      dispatch(findAllBrand());
    }
  }, [dispatch, show]);


  const fields = [
    {
      name: 'brand.id',
      label: 'Izaberi Brend',
      type: 'select',
      options: brandList?.map((brand) => ({
        value: brand.id,
        label: brand.brandName,
      })),
    },
    {
      name: 'modelName',
      label: ModalForAddOrUpdateVehicleModel.vehicleModelNamePlaceholder,
      type: 'text',
    },
  ];


  const initialValues = {
    modelName: '',
    ['brand.id']: '',
  };

  const handleSubmit = (formData) => {
    const payload = {
      modelName: formData.modelName,
      brand: {
        id: Number(formData['brand.id']),
      },
    };

    handleAdd(payload);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      onSubmit={handleSubmit}
      title={ModalForAddOrUpdateVehicleModel.titleForAddVehicleModel}
      fields={fields}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.save}
    />
  );
};

export default ModalForAddVehicleModel;